<template>
    <div>
        <el-form :model="from" :rules="rules" ref="ruleForm" label-width="170px">
            <table style="width: 95%; margin: 0 2%; margin-top: 20px;">
                <tr>
                    <td style="height: 30px; width: 25%;">
                        <el-form-item prop="staff_name" style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">姓名：</span>
                            </template>
                            <el-input placeholder="请输入姓名" v-model="from.staff_name" size="small" style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item prop="staff_gender" style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">性别：</span>
                            </template>
                            <el-radio v-model="from.staff_gender" label="1">男</el-radio>
                            <el-radio v-model="from.staff_gender" label="0">女</el-radio>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item prop="staff_card" style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">身份证号：</span>
                            </template>
                            <el-input placeholder="请输入身份证号" type="number" v-model="from.staff_card" size="small" style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">出生日期：</span>
                            </template>
                            <el-date-picker v-model="from.birth_date" type="date" placeholder="请选择出生日期"
                                style="width: 100%;" value-format="yyyy-MM-dd" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">年龄：</span>
                            </template>
								<el-input placeholder="请输入年龄" type="number" v-model="from.age" size="small" style="width: 100%;">
								</el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item prop="staff_telephone" style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">手机号：</span>
                            </template>
                            <el-input placeholder="请输入手机号" v-model="from.staff_telephone" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">民族：</span>
                            </template>
                            <el-input placeholder="请输入民族" v-model="from.nation" size="small" style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">籍贯：</span>
                            </template>
                            <el-input placeholder="请输入籍贯" v-model="from.native_place" size="small" style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">身份证地址：</span>
                            </template>
                            <el-input placeholder="请输入身份证地址" v-model="from.card_address" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">现居住地地址：</span>
                            </template>
                            <el-input placeholder="请输入现居住地地址" v-model="from.residence" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">户口所在地：</span>
                            </template>
                            <el-input placeholder="请输入户口所在地" v-model="from.domicile_place" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">户籍性质：</span>
                            </template>
                            <el-select v-model="from.household_register_id" placeholder="请选择户籍性质" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in householdRegisterList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">银行卡号：</span>
                            </template>
                            <el-input placeholder="请输入银行卡号" v-model="from.bank_no" size="small" style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">第一学历：</span>
                            </template>
                            <el-select v-model="from.first_degree_id" placeholder="请选择第一学历" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in firstDegreeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">最高学历：</span>
                            </template>
                            <el-select v-model="from.second_degree_id" placeholder="请选择最高学历" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in secondDegreeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">健康状况：</span>
                            </template>
                            <el-select v-model="from.health_id" placeholder="请选择健康状况" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in healthList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">邮箱：</span>
                            </template>
                            <el-input placeholder="请输入邮箱" v-model="from.mailbox" size="small" style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">微信：</span>
                            </template>
                            <el-input placeholder="请输入微信" v-model="from.we_chat" size="small" style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
        </el-form>
    </div>
</template>

<script>
    export default {
        props: ["from"],
        data() {
            var rulesPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入手机号！'));
                } else {
                    const reg = /^1[3456789]\d{9}$/;
                    console.log(reg.test(value));
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('手机号格式错误！'));
                    }
                }
            };
            var rulesCard = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入身份证号码'));
                } else {
                    const reg =
                        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
                    console.log(reg.test(value));
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('身份证格式错误'));
                    }
                }
            };
            return {
                //表单验证
                rules: {
                    staff_name: [{
                        required: true,
                        message: '请输入姓名！',
                        trigger: 'blur'
                    }],
                    staff_gender: [{
                        required: true,
                        message: '请选择性别！',
                        trigger: 'blur'
                    }],
                    staff_card: [{
                        required: true,
                        validator: rulesCard,
                        trigger: 'blur'
                    }],
                    staff_telephone: [{
                        required: true,
                        validator: rulesPhone,
                        trigger: 'blur'
                    }],
                },

                //户籍性质
                householdRegisterList: [],
                //第一学历
                firstDegreeList: [],
                //最高学历
                secondDegreeList: [],
                //健康状况
                healthList: [],
            }
        },
        async created() {
            //初始化户籍性质
            var householdRegisterList = await this.$globals.AxiosPost("dictionaries/selectFind", {
                data_grouping: "household_register"
            });
            this.householdRegisterList = householdRegisterList.data;

            //初始化第一学历
            var firstDegreeList = await this.$globals.AxiosPost("dictionaries/selectFind", {
                data_grouping: "first_degree"
            });
            this.firstDegreeList = firstDegreeList.data;

            //初始化最高学历
            var secondDegreeList = await this.$globals.AxiosPost("dictionaries/selectFind", {
                data_grouping: "second_degree"
            });
            this.secondDegreeList = secondDegreeList.data;

            //初始化健康状况
            var healthList = await this.$globals.AxiosPost("dictionaries/selectFind", {
                data_grouping: "health"
            });
            this.healthList = healthList.data;
        }
    }
</script>

<style scoped="scoped">
    >>>.el-radio__input.is-checked .el-radio__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-radio__input.is-checked+.el-radio__label {
        color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// basic.vue?291d98c7